// External
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Internal
import { UiDropdownComponent } from './ui-dropdown.component';
import { DirectivesModule } from '../../directives.module';
import { UiIconModule } from '../ui-icon/ui-icon.module';

@NgModule({
    declarations: [
        UiDropdownComponent
    ],
    imports: [
        CommonModule,
        DirectivesModule,
        UiIconModule
    ],
    exports: [ UiDropdownComponent ]

})

export class UiDropdownModule {}
